import { WHATSAPP_LINK } from "@/pages/home/constants";

export default function PromoBanner() {
  return (
    <section id="bonus-exclusivo" className="relative py-3 md:py-6 bg-background-50 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto reveal">
          <div className="relative overflow-hidden rounded-xl md:rounded-2xl bg-primary-900 border border-accent-500/40 px-3.5 py-3.5 md:px-7 md:py-5">
            <div
              className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-accent-500/10"
              aria-hidden="true"
            />
            <div className="relative flex flex-col md:flex-row md:items-center gap-2.5 md:gap-5">
              <div className="flex items-center gap-2.5 md:gap-4 flex-1 min-w-0">
                <div className="w-9 h-9 md:w-12 md:h-12 shrink-0 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-coupon-3-line text-primary-950 text-lg md:text-2xl" />
                </div>
                <div className="min-w-0 text-left">
                  <p className="text-[9px] md:text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-400 mb-0.5">
                    Vantagem exclusiva
                  </p>
                  <h3 className="text-xs md:text-base font-heading font-bold text-white leading-snug">
                    Fechando o passeio com a Eco Tour, você pode ganhar ingressos e descontos em parques e
                    cachoeiras de Capitólio.
                  </h3>
                </div>
              </div>
              <a
                href={WHATSAPP_LINK}
                data-whatsapp-cta
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-full md:w-auto inline-flex items-center justify-center gap-2 px-4 py-2 md:py-2.5 rounded-md text-[11px] md:text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-sm md:text-lg" />
                Quero garantir
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}